import { getThemeData } from '@hzero-front-ui/core';
import { css } from 'styled-components';
// 该组件都是用ProgressPro中的共同样式模板
// 部分颜色，与设计稿中颜色不匹配，单独管理
var colors = {
  primary: '#29BECE',
  success: '#00bf96',
  exception: '#d50000'
};
var getProgressStyle = function getProgressStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary = _getThemeData.primary;
  return css([".c7n-progress-loading.c7n-progress-loading{display:inline-block;&.c7n-progress-status-normal{.c7n-progress-inner circle{stroke:", ";}}&.c7n-progress-status-success{.c7n-progress-inner circle{stroke:", ";}}&.c7n-progress-status-exception{.c7n-progress-inner circle{stroke:", ";}}}"], primary, colors.success, colors.exception);
};
var progressData = {
  name: 'progress',
  data: [{}],
  onlyTemplate: {
    base: getProgressStyle
  }
};
var lineProgressData = {
  name: 'lineProgress',
  data: [{
    normalBg: '#29BECE',
    exceptionBg: '#d50000',
    successBg: '#00bf96',
    showExtra: false,
    hideRightIcon: false
  }]
};
var circleProgressData = {
  name: 'circleProgress',
  data: [{
    // 数组的原因是模板提供了渐变色的效果，但是孔雀蓝不需要渐变，因此给了相同色彩
    normalStopColors: [colors.primary, colors.primary],
    successStopColors: [colors.success, colors.success],
    exceptionStopColors: [colors.exception, colors.exception],
    succBgColor: colors.success,
    execBgColor: colors.exception,
    fontColor: '#333',
    fontSize: '24px',
    fontWeight: 500,
    textBottomFontWeight: 500,
    pointerNormalColr: colors.primary
  }]
};
export { progressData, lineProgressData, circleProgressData };